export const AVAILABLE_LANGUAGES = [
  { title: 'Português (brasileiro)', value: 'pt-BR' },
  { title: 'English', value: 'en-US' },
  { title: 'Español', value: 'es' },
  { title: '中文', value: 'ch' }
]
